import { logCoreUsage } from 'owa-analytics';
import type { CustomData } from 'owa-analytics-types';
export type A2HSMetric = any;

export const logMetric = (metricName: A2HSMetric, customData?: CustomData) => {
    logCoreUsage('A2HS_' + metricName, customData);
};
